export default __webpack_public_path__ + "static/char-s-30-en-4abbd02e11f149ab5c0165554aed0871.png";